import { createSelector } from '@reduxjs/toolkit';
import { leavePeriods } from './leave-periods';

export const leavePeriodsConfirmed = createSelector(leavePeriods, (periods) => {
  return periods.filter((p) => p.confirmed);
});
